import {Col, Row} from 'antd';
import React from 'react';

// import generalized1 from '../../../../../../assets/generalized1.png';
import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
// import CTABanner from '../../../../components/CTABanner';
import {rowGutterNZM} from '../../../../constants/commonConstants';
import AllSuppliers from '../../../../supplyChain/utils/AllSuppliers';

const OperationalWater: React.FC<{data: any[]}> = ({data}) => {
  const waterInfo = InformativeText?.NZM?.utility?.water;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
        {/* Last colspan was 14 */}
        <Col span={24} style={{height: '100%'}}>
          <AllSuppliers
            data={data}
            keyArray={['water withdrawn per floor space']}
            type="waterOps"
            customTitle="TOTAL FACILITY"
            tooltip={waterInfo?.Water_withdrawn_per_floor_space}
          />
        </Col>
        {/* <Col span={10}>
          <CTABanner
            mainTitle="Lorem ipsum dolor sit amet."
            desc="Lorem ipsum dolor sit amet consectetur adipisicing elit. Illo autem
          fuga, sed deserunt laboriosam ut quas minima iste aliquid consequuntur
          accusantium minus nobis blanditiis ullam"
            img={generalized1}
            isLandscape={false}
          />
        </Col> */}
      </Row>
    </>
  );
};

export default OperationalWater;
